import TorMySchoolPage from './components/TorMySchoolPage.vue';

export default {
  routes: [
    {
      path: '/',
      component: TorMySchoolPage,
      name: 'torMySchool',
    },
  ],
};
